module.exports = __webpack_public_path__ + "img/product_79.16e4584.webp";